/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Train_TitleInputs */

const en_how_page_train_title = /** @type {(inputs: How_Page_Train_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train to the plan.`)
};

const pl_how_page_train_title = /** @type {(inputs: How_Page_Train_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuj według planu.`)
};

/**
* | output |
* | --- |
* | "Train to the plan." |
*
* @param {How_Page_Train_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_train_title = /** @type {((inputs?: How_Page_Train_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Train_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_train_title(inputs)
	return en_how_page_train_title(inputs)
});